// extracted by mini-css-extract-plugin
export default {"emptyTrashOutlinedButton":"emptyTrash_emptyTrashOutlinedButton__MOsTh"};